import { createContext } from 'react'
import { getTheme } from './ui/theme'

export const StateContext = createContext(null)
export const DispatchStateContext = createContext(null)


export const DevMode = createContext(null);

export const ThemeContext = createContext(null)

